module.exports = __webpack_public_path__ + "img/login_bg.c10be636.png";